export default __webpack_public_path__ + "static/media/airtel_payments_bank_logo.4667dc12.png";